import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import orderBy from 'lodash/orderBy';
import moment from 'moment';

import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';

import { todos } from 'Shared/reducers/todos';

import { mergedSyncList } from './utils';

export const listFromType = meetingItemType => {
  if (meetingItemType === 'action_item') {
    return 'meeting_items';
  }
  if (meetingItemType === 'discussion_topic') {
    return 'discussion_topics';
  }

  return null;
};

const workspaceInitialState = {
  discussion_topics: [],
  meeting_items: [],
  requestedTimelineFilters: {
    created_at: [],
    completed_at: [],
  },
  timelineGroups: [],
  users: [],
  loading: true,
};

export default function workspace(state = workspaceInitialState, action) {
  switch (action.type) {
    case 'WORKSPACE_GET_ERROR':
      return { ...state, loading: false };
    case 'WORKSPACE_GET_REQUEST':
      return { ...state, id: action.payload, loading: true };
    case 'WORKSPACE_GET_RESPONSE':
      return {
        ...action.data,
        timelineGroups: state.timelineGroups || [],
        presenceData: state.presenceData || action.data.presenceData,
      };
    case 'WORKSPACE_UPDATES_GET_RESPONSE': {
      const updatedActionItems = mergedSyncList({
        currentList: state.meeting_items,
        newList: action.payload.meeting_items,
      });
      const updatedDiscussionTopics = mergedSyncList({
        currentList: state.discussion_topics,
        newList: action.payload.discussion_topics,
      });

      return {
        ...action.payload,
        meeting_items: updatedActionItems,
        discussion_topics: updatedDiscussionTopics,
        timelineGroups: state.timelineGroups || [],
      };
    }
    case 'WORKSPACE_UPDATE_RESPONSE':
      return {
        ...state,
        ...action.payload.params,
      };
    case 'WORKSPACE_TIMELINE_GROUPS_GET_RESPONSE':
      return {
        ...state,
        timelineGroups: action.payload,
      };
    case 'WORKSPACE_FEEDBACKS_GET_RESPONSE':
      return {
        ...state,
        feedbacks: mergedSyncList({
          currentList: state.feedbacks,
          newList: action.payload.feedbacks || [],
        }),
      };
    case 'DELETE_WORKSPACE_RECURRENCE_RESPONSE':
    case 'SET_WORKSPACE_RECURRENCE_RESPONSE':
      return {
        ...state,
        recurrence: action.payload.recurrence,
        manualNextEventDate: action.payload.manualNextEventDate,
      };
    case 'SET_CALENDAR_MEETING_REQUEST':
    case 'SET_CALENDAR_MEETING_RESPONSE':
    case 'SET_CALENDAR_MEETING_ERROR':
      return {
        ...state,
        calendarMeeting: action.payload.calendarMeeting,
      };
    case 'SET_RECURRING_MEETING_REQUEST':
    case 'SET_RECURRING_MEETING_RESPONSE':
    case 'SET_RECURRING_MEETING_ERROR':
      return {
        ...state,
        recurringMeeting: action.payload.recurringMeeting,
      };
    case 'TOGGLE_ITEM_TYPE': {
      const switchFromKey = action.payload.newItemType === 'action_item' ? 'discussion_topics' : 'meeting_items';
      const switchToKey = action.payload.newItemType === 'action_item' ? 'meeting_items' : 'discussion_topics';
      return {
        ...state,
        [switchToKey]: [
          ...state[switchFromKey]
            .filter(({ uuid, parentUuid }) => uuid === action.payload.uuid || parentUuid === action.payload.uuid)
            .map(item => ({
              ...item,
              itemType: action.payload.newItemType,
              parentId: item.uuid === action.payload.uuid && item.parentUuid ? null : item.parentId,
              parentUuid: item.uuid === action.payload.uuid && item.parentUuid ? null : item.parentUuid,
              dueBy: action.payload.dueBy,
            })),
          ...state[switchToKey],
        ],
        [switchFromKey]: state[switchFromKey].filter(
          ({ uuid, parentUuid }) => uuid !== action.payload.uuid && parentUuid !== action.payload.uuid
        ),
      };
    }
    case 'UPDATE_MEETING_ITEM_RESPONSE':
    case 'UPDATE_MEETING_ITEM_ERROR':
    case 'MEETING_ITEM_BULK_ADD_REQUEST':
    case 'MEETING_ITEM_BULK_ADD_RESPONSE':
    case 'MEETING_ITEM_BULK_ADD_ERROR':
    case 'MEETING_ITEM_ADD_REQUEST':
    case 'BULK_UPDATE_MEETING_ITEM_RESPONSE':
    case 'MEETING_ITEM_WITH_CHILD_ADD_REQUEST':
    case 'MEETING_ITEM_WITH_CHILD_ADD_RESPONSE':
    case 'MEETING_ITEM_WITH_CHILD_ADD_ERROR':
    case 'MEETING_ITEM_ADD_RESPONSE':
    case 'MEETING_ITEM_ADD_ERROR':
    case 'MEETING_ITEM_SET_COMPLETED_REQUEST':
    case 'MEETING_ITEM_SET_COMPLETED_RESPONSE':
    case 'MEETING_ITEM_REMOVE_REQUEST':
    case 'MEETING_ITEM_REMOVE_ERROR':
    case 'MEETING_ITEM_UPDATE_REQUEST':
    case 'MEETING_ITEM_REMOVE_NESTING_REQUEST':
    case 'MEETING_ITEM_NEST_REQUEST':
    case 'MEETING_ITEM_DROP_REQUEST':
    case 'MEETING_ITEM_REMOVE_ATTACHMENT_RESPONSE':
    case 'CREATE_WORKSPACE_COMMENT_REQUEST':
    case 'CREATE_WORKSPACE_COMMENT_RESPONSE':
    case 'CREATE_WORKSPACE_COMMENT_ERROR':
    case 'DESTROY_WORKSPACE_COMMENT_REQUEST':
    case 'DESTROY_WORKSPACE_COMMENT_ERROR':
    case 'UPDATE_COMMENT_ITEM_RESPONSE':
    case 'REMOVE_COMMENT_ATTACHMENT_RESPONSE':
    case 'ADD_MEETING_ITEM_ATTACHMENT_RESPONSE':
    case 'UPDATE_MEETING_ITEM_RECURRENCE':
    case 'REMOVE_MEETING_ITEM_RECURRENCE': {
      const listType = listFromType(action.meetingItemType);
      return {
        ...state,
        [listType]: todos(state[listType], action),
      };
    }
    case 'MEETING_ITEMS_SYNC': {
      const newActionItems = mergedSyncList({
        currentList: state.meeting_items,
        newList: action.meetingItems,
        deletedList: action.deletedMeetingItems,
      });
      const newDiscussionTopics = mergedSyncList({
        currentList: state.discussion_topics,
        newList: action.discussionTopics,
        deletedList: action.deletedDiscussionTopics,
      });

      return {
        ...state,
        meeting_items: orderBy(newActionItems, ['position']),
        discussion_topics: orderBy(newDiscussionTopics, ['position']),
        isAllCompletedItemsInStore: action.filter === 'completed' || state.isAllCompletedItemsInStore,
        requestedTimelineFilters: {
          created_at:
            action.filter === 'timeline' && action.groupBy === 'created_at' && action.requestedTimelineGroups
              ? [...state.requestedTimelineFilters?.created_at, ...action.requestedTimelineGroups]
              : state.requestedTimelineFilters?.created_at,
          completed_at:
            action.filter === 'timeline' && action.groupBy === 'completed_at' && action.requestedTimelineGroups
              ? [...state.requestedTimelineFilters?.completed_at, ...action.requestedTimelineGroups]
              : state.requestedTimelineFilters?.completed_at,
        },
      };
    }
    case 'PRESENCE_DATA_SYNC': {
      return { ...state, presenceData: action.payload };
    }
    case 'VIEW_NEW_WORKSPACE_COMMENT':
    case 'VIEW_NEW_WORKSPACE_ITEM':
      return {
        ...state,
        workspaceNotifications: {
          ...state.workspaceNotifications,
          [action.notificationField]: state.workspaceNotifications?.[action.notificationField]?.filter(
            uuid => !action.payload.includes(uuid)
          ),
        },
      };
    case 'RESET_WORKSPACE_NOTIFICATIONS':
    case 'WORKSPACE_NOTIFICATIONS_SYNC':
      if (state.id === action.payload.workspaceId)
        return {
          ...state,
          workspaceNotifications: {
            count: 0,
            modifiedItemsUuids: uniq([
              ...state.workspaceNotifications.modifiedItemsUuids,
              ...action.payload.workspaceNotifications.modifiedItemsUuids,
            ]),
            modifiedCommentsUuids: uniq([
              ...state.workspaceNotifications.modifiedCommentsUuids,
              ...action.payload.workspaceNotifications.modifiedCommentsUuids,
            ]),
            viewedWorkspace: action.payload.workspaceNotifications.viewedWorkspace,
            viewedWorkspaceTime: state.workspaceNotifications.viewedWorkspaceTime,
          },
        };
      return state;
    case 'MEETING_ITEM_BULK_UPDATE_REQUEST':
    case 'MEETING_ITEM_BULK_REMOVE_REQUEST':
    case 'DUPLICATE_ACROSS_WORKSPACES_RESPONSE':
    case 'MEETING_ITEM_BULK_UPDATE_ERROR': {
      return {
        ...state,
        meeting_items: todos(state.meeting_items, action),
        discussion_topics: todos(state.discussion_topics, action),
      };
    }

    case 'CLEAR_COMPLETED_ITEMS': {
      const startOfWeek = moment().startOf('week').unix();
      return {
        ...state,
        requestedTimelineFilters: {
          created_at: [],
          completed_at: [],
        },
        meeting_items: state.meeting_items.filter(
          ({ completedAt, completed }) => !completed || completedAt > startOfWeek
        ),
        discussion_topics: state.discussion_topics.filter(
          ({ completedAt, completed }) => !completed || completedAt > startOfWeek
        ),
      };
    }
    case 'CLEAR_WORKSPACE':
      return workspaceInitialState;

    // This is needed hopefully temporarily to allow updates from the new MeetingItem.Actions to flow
    // into the older state object to render udpates
    case MeetingItemsConstants.Actions.FETCH_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_SINGLE_MEETING_ITEMS_SUCCESS:
      return {
        ...state,
        meeting_items: uniqBy(
          [
            ...state.meeting_items,
            ...Object.values(action.payload.meetingItem)
              .filter(item => item.attributes.itemType === 'action_item' && item.attributes.workspaceId === state.id)
              .map(item => {
                return item.attributes;
              }),
          ],
          'uuid'
        ),
        discussion_topics: uniqBy(
          [
            ...state.discussion_topics,
            ...Object.values(action.payload.meetingItem)
              .filter(
                item => item.attributes.itemType === 'discussion_topic' && item.attributes.workspaceId === state.id
              )
              .map(item => {
                return item.attributes;
              }),
          ],
          'uuid'
        ),
      };
    default:
      return state;
  }
}
